module.exports = __webpack_public_path__ + "img/logo_blue.7c872665.svg";